import { useEffect, useState } from 'react'
import { getCurrentChatUser, isCachedChatUser, resolveSelfUserId } from '../services/chat-service'

/**
 * The signed-in user's chat id for call signalling. Uses the cached chat
 * profile only when it belongs to `authUserId`; otherwise (cold cache, or a
 * profile left over from the previous account on this device) it refetches.
 */
export function useSelfChatUserId(authUserId: string | undefined): string | undefined {
  const [chatUserId, setChatUserId] = useState<string | undefined>(() =>
    resolveSelfUserId(authUserId),
  )

  useEffect(() => {
    if (!authUserId) {
      setChatUserId(undefined)
      return
    }

    if (isCachedChatUser(authUserId)) {
      setChatUserId(authUserId)
      return
    }

    // Never keep a previous account's id while the refetch is in flight.
    setChatUserId(authUserId)
    let cancelled = false
    void getCurrentChatUser()
      .then((me) => {
        if (!cancelled) setChatUserId(me.userId)
      })
      .catch(() => {
        /* keep the authenticated id */
      })
    return () => {
      cancelled = true
    }
  }, [authUserId])

  return chatUserId
}
